import { render } from "./IDPDocumentClasses.vue?vue&type=template&id=810582e8&scoped=true"
import script from "./IDPDocumentClasses.vue?vue&type=script&lang=js"
export * from "./IDPDocumentClasses.vue?vue&type=script&lang=js"

import "./IDPDocumentClasses.vue?vue&type=style&index=0&id=810582e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810582e8"]])

export default __exports__